import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GreetingData } from './greeting.service';
 
@Component({
  selector: 'app-greeting-popup',
  templateUrl: './greeting.component.html',
  styleUrls: ['./greeting.component.scss']
})
export class GreetingComponent {
  @Input() greeting: GreetingData | null = null;
  @Output() dismissed = new EventEmitter<void>();
 
  constructor() { }
 
  onDismiss(): void {
    this.dismissed.emit();
  }
}